// extracted by mini-css-extract-plugin
export default {"base":"DialogBody_base__bWR9m"};